



















































































































import Vue, { PropType } from "vue";
import { ApplicationPlansProps } from "@/components/ApplicationPlans/ApplicationPlans.vue";
import queryString from "qs";

export interface UpdatepassPaymentConfirmProps {
  action: string;
  lang: any;
  serialNumber: string;
  locale: string;
  countryChoice: any;
  currencyChoice: any;
  defaultData: any;
  updatepassPlanCode: string;
  updatepassPriceMap: any;
  freeTrialType: any;
  settlementScheduledAt: number;
  payWithPaypalLink: string;
  payWithPaypalText: string;
  payWithPaypalUsdOnlyText: string;
  prevUrl: string;
}
export default Vue.extend({
  name: "vc-updatepass-payment-confirm",
  data() {
    return {
      country_code: this.defaultData.country_code,
      currency_code: this.defaultData.currency_code
    };
  },
  props: {
    action: {
      type: String as PropType<UpdatepassPaymentConfirmProps["action"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<UpdatepassPaymentConfirmProps["lang"]>,
      default: () => {}
    },
    serialNumber: {
      type: String as PropType<UpdatepassPaymentConfirmProps["serialNumber"]>,
      default: ""
    },
    locale: {
      type: String as PropType<UpdatepassPaymentConfirmProps["locale"]>,
      default: ""
    },
    countryChoice: {
      type: Array as PropType<UpdatepassPaymentConfirmProps["countryChoice"]>,
      default: () => []
    },
    currencyChoice: {
      type: Array as PropType<UpdatepassPaymentConfirmProps["currencyChoice"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<UpdatepassPaymentConfirmProps["defaultData"]>,
      default: () => {}
    },
    updatepassPlanCode: {
      type: String as PropType<
        UpdatepassPaymentConfirmProps["updatepassPlanCode"]
      >,
      default: ""
    },
    updatepassPriceMap: {
      type: Object as PropType<
        UpdatepassPaymentConfirmProps["updatepassPriceMap"]
      >,
      default: () => {}
    },
    settlementScheduledAt: {
      type: Number as PropType<
        UpdatepassPaymentConfirmProps["settlementScheduledAt"]
      >,
      default: 0
    },
    freeTrialType: {
      type: String as PropType<UpdatepassPaymentConfirmProps["freeTrialType"]>,
      default: ""
    },
    payWithPaypalLink: {
      type: String as PropType<
        UpdatepassPaymentConfirmProps["payWithPaypalLink"]
      >,
      default: ""
    },
    payWithPaypalText: {
      type: String as PropType<
        UpdatepassPaymentConfirmProps["payWithPaypalText"]
      >,
      default: ""
    },
    payWithPaypalUsdOnlyText: {
      type: String as PropType<
        UpdatepassPaymentConfirmProps["payWithPaypalUsdOnlyText"]
      >,
      default: ""
    },
    prevUrl: {
      type: String as PropType<ApplicationPlansProps["prevUrl"]>,
      default: ""
    }
  },
  computed: {
    firstCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 2) return true;
      });
    },
    todayPrice(): any {
      let price = this.updatepassPriceMap[this.updatepassPlanCode][
        this.currency_code
      ];
      if (!(this.freeTrialType === null)) {
        price = 0;
      }
      return price;
    },
    yearlyPrice(): any {
      return this.updatepassPriceMap[this.updatepassPlanCode][
        this.currency_code
      ];
    },
    payWithPaypalLinkWithCurrency(): string {
      const params = {
        currency: this.currency_code
      };
      return this.payWithPaypalLink + `?${queryString.stringify(params)}`;
    }
  },
  methods: {
    submitSerialNumber() {
      const formElement = this.$refs.formOffers as HTMLFormElement;
      const inputSerialNumber = document.createElement("input");
      inputSerialNumber.setAttribute("type", "hidden");
      inputSerialNumber.setAttribute("name", "serial_number");
      inputSerialNumber.setAttribute("value", this.serialNumber);
      formElement.appendChild(inputSerialNumber);
      formElement.submit();
    }
  },
  watch: {}
});
